import {useEffect, useState} from "react";
import { Footer, Header} from "../components";
import { PortfolioItem } from "../components/parts";
import { projects } from "../config";

const Portfolio = () => {

  const [filteredProjects, setFilteredProjects] = useState()
  const [category, setCategory] = useState()

  const handleChangeCategory = (category = '') => {
    setCategory(category)

    const allLinks = document.querySelectorAll('.button-group button')

    for (let i = 0; i < allLinks.length; i++) {
      allLinks[i].classList.remove('active')
    }

    if (category) {
      document.querySelector(`.button-group .${category}`).classList.add('active')
    } else {
      document.querySelector(`.button-group .all`).classList.add('active')
    }
  }

  useEffect(() => {
    const loadProjects = () => {
      if (category) {
        setFilteredProjects(projects.filter(p => p.category === category))
      } else {
        setFilteredProjects(projects)
      }
    }

    loadProjects()
  }, [category])

  return (
    <>
      <Header />
      <section className="py-24 md:py-32 px-5 md:px-32">
          <div className="mb-10">
            <h1 className="text-4xl font-medium mb-3">
            My <span className="text-primary">portfolio</span>
            </h1>
            <p className="text-lg font-light text-gray-300">Check out all the projects I've had</p>
          </div>
          <div className="flex mb-5 button-group">
              <button className="px-5 py-1 rounded hover:bg-primary hover:text-white focus:bg-primary focus:text-white animation duration-500 all active" onClick={() => handleChangeCategory()}>All</button>
              <button className="px-5 py-1 rounded hover:bg-primary hover:text-white focus:bg-primary focus:text-white animation duration-500 web" onClick={() => handleChangeCategory('web')}>Web</button>
              <button className="px-5 py-1 rounded hover:bg-primary hover:text-white focus:bg-primary focus:text-white animation duration-500 mobile" onClick={() => handleChangeCategory('mobile')}>Mobile</button>
              <button className="px-5 py-1 rounded hover:bg-primary hover:text-white focus:bg-primary focus:text-white animation duration-500 uiux" onClick={() => handleChangeCategory('uiux')}>UI/UX</button>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                {filteredProjects && filteredProjects.map((project) => (
                    <PortfolioItem key={project.id} data={project} isRounded  />
                ))}
          </div>
      </section>
      <Footer/>
    </>
  );
};

export default Portfolio;
